import { translate } from '@vestahealthcare/common/i18n';

export const INCIDENTS_PAGE_TAB_OPEN = 'tab-open';
export const INCIDENTS_PAGE_TAB_ALL = 'tab-all';

export type IncidentPageTabType = 'tab-open' | 'tab-all';

export const INCIDENT_TABS = [
  {
    label: translate('incidents.tabs.all'),
    value: INCIDENTS_PAGE_TAB_ALL,
  },
  {
    label: translate('incidents.tabs.open'),
    value: INCIDENTS_PAGE_TAB_OPEN,
  },
];
